import { Params } from '@angular/router';
import { IgUser } from '@core/models/ApiFields/ig-entities';
import { IData, ReqMode } from '@core/models/IApi';
import { PageFiltersState } from '@features/social-analysis/social-shared/store/page-filters.store';
import { TableState } from '@features/social-analysis/social-shared/store/table.store';
import { TableHttpBuilder } from '../../social-shared/services/http/table-simple-http';
import { igUsersFields } from '../config/users-table.config';

export class UsersHttpBuilder extends TableHttpBuilder {
    protected buildParams(
        { limit, offset, sorting, hiddenSort }: TableState<IData>,
        pageFilters: PageFiltersState,
        mode: ReqMode
    ): Params {
        const dates = this.getDates(pageFilters.selectedDates());
        return {
            ...dates,
            fields: this.getFields(),
            limit: limit(),
            offset: offset(),
            sort: this.formatSorting(sorting(), hiddenSort),
            mode: mode,
            ...this.formatFilters(pageFilters.appliedFilters()),
            ...this.getUserLevelFilter(),
        };
    }

    private getFields(): string {
        return igUsersFields.join();
    }

    private getUserLevelFilter() {
        return { [IgUser.getPrefixed('level')]: 'eq:1' };
    }
}
